import * as React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import Badge from '@material-ui/core/Badge'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import BreadCrumb from '../../shared/components/BreadCrumb'
import SiteCoreService from '../../core/services/SiteCoreService'
import DownArrow from '@material-ui/icons/KeyboardArrowDown'
import UpArrow from '@material-ui/icons/KeyboardArrowUp'
import Loading from '../../shared/components/loading/Loading';
import { NavLink } from 'react-router-dom';
import { getSubscriptionStatistics } from "../../shared/services/SubscriptionsApi";
import {
  ISubscriptionStatistics
} from "../../shared/models/SubscriptionStatistics";
import { ISubscriptionStatisticState } from "../../shared/models/ISubscriptionStatisticState";
import { ISubscriptionStatisticEnvironment } from "../../shared/models/ISubscriptionStatisticEnvironment";
import { ISubscriptionStatistic } from "../../shared/models/ISubscriptionStatistic";
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";
import { SubscriptionStatusEnum } from "../../shared/models/SubscriptionStatusEnum";

const siteCoreService = SiteCoreService.Instance

interface IState {
  isLoading: boolean;
  pending: { Live: number, Sandbox: number };
  statistics: ISubscriptionStatistics | undefined;
  sitecoreAssets: ISitecoreAsset[];
  showSubscriptions: boolean;
}

class Verifications extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      pending: { Live: 0, Sandbox: 0 },
      statistics: undefined,
      sitecoreAssets: [],
      showSubscriptions: false,
    }
  }

  public async componentDidMount() {
    const [statistics, sitecoreAssets]: [ISubscriptionStatistics | undefined, ISitecoreAsset[]] = await Promise.all([
      getSubscriptionStatistics(),
      siteCoreService.getAllSiteCoreAssets()
    ])

    this.setState({
      ...this.state,
      sitecoreAssets,
      statistics,
      isLoading: false,
      pending: this.calculatePending(statistics)
    })
  }

  public calculatePending(statistics: ISubscriptionStatistics | undefined) {
    const pendingSubscriptions = {
      Live: 0,
      Sandbox: 0
    }

    if (!statistics || !statistics.assets) {
      return pendingSubscriptions;
    }

    // @ts-ignore
    const assetEnvironments = statistics.assets.flatMap((a: ISubscriptionStatistic) => a.environments);

    assetEnvironments.forEach((environment: ISubscriptionStatisticEnvironment) => {
      environment.states.forEach((state: ISubscriptionStatisticState) => {
        if (state.name === SubscriptionStatusEnum.Requested) {
          pendingSubscriptions[environment.name] += state.subscriptions;
        }
      })
    });

    return pendingSubscriptions;
  }


  public render() {
    const { isLoading, statistics, pending, showSubscriptions, sitecoreAssets } = this.state;
    return (
      <div>
        <Typography variant="title">
          Subscription Requests
          </Typography>
        <Typography color="textSecondary" gutterBottom>
          <BreadCrumb
            value='Console'
            to='/'
          />
          Assets
          </Typography>
        {isLoading &&
          <Loading />
        }
        {!isLoading &&
          <div>    
            <div className="padding-bottom-24" />
            {!(statistics && statistics.assets && statistics.assets.length > 0) &&
              <Typography>
                There are no assets to manage.
                </Typography>
            }
            {statistics && statistics.assets && statistics.assets.length > 0 &&
              <div>
                <Typography variant="button">
                  Allow or Deny pending subscriptions
                </Typography>
                <div className="padding-bottom-24" />
                <Grid container spacing={24}>
                  <Grid item>
                    <Badge style={{ visibility: pending.Live === 0 ? "hidden" : "visible" }} badgeContent={pending.Live} color="secondary">
                      <Card style={{ visibility: "visible" }}>
                        <CardContent>
                          <Typography style={{ textAlign: 'center' }} gutterBottom>
                            LIVE ENVIRONMENTS
                            </Typography>
                          <Typography variant="caption" style={{ textAlign: 'center' }}>
                            {pending.Live} PENDING REQUESTS
                            </Typography>
                          <div className="padding-bottom-24" />
                          <Button component={(componentProps: any) => <NavLink {...componentProps} to={"/pending-subscriptions/Live"} />} variant="outlined" color="secondary" fullWidth>Details</Button>
                        </CardContent>
                      </Card>
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Badge style={{ visibility: pending.Sandbox === 0 ? "hidden" : "visible" }} badgeContent={pending.Sandbox} color="secondary">
                      <Card style={{ visibility: "visible" }}>
                        <CardContent>
                          <Typography style={{ textAlign: 'center' }} gutterBottom>
                            SANDBOX ENVIRONMENTS
                            </Typography>
                          <Typography variant="caption" style={{ textAlign: 'center' }}>
                            {pending.Sandbox} PENDING REQUESTS
                            </Typography>
                          <div className="padding-bottom-24" />
                          <Button component={(componentProps: any) => <NavLink {...componentProps} to={"/pending-subscriptions/false"} />} variant="outlined" color="secondary" fullWidth>Details</Button>
                        </CardContent>
                      </Card>
                    </Badge>
                  </Grid>
                </Grid>
                <div className="padding-bottom-24" />
                <div className="padding-bottom-24" />
                {!showSubscriptions &&
                  <Button onClick={(e: any) => this.setState({ showSubscriptions: true })}>
                    Manage Existing Subscriptions<DownArrow />
                  </Button>
                }
                {showSubscriptions &&
                  <div>
                    <Button onClick={(e: any) => this.setState({ showSubscriptions: false })}>
                      Manage Existing Subscriptions<UpArrow />
                    </Button>
                    <div className="padding-bottom-24" />
                    <Grid container spacing={16} alignItems="stretch">
                      {statistics.assets && statistics.assets.map((asset: ISubscriptionStatistic) => {
                        return (
                          <Grid key={asset.id} item xs={12} sm={6} md={4} lg={3}>
                            <Card style={{ width: "100%", height: "100%" }}>
                              <CardContent style={{ padding: 32, paddingBottom: 0 }}>
                                <Grid container direction="column" alignItems="stretch" justify="flex-end">
                                  <Grid item>
                                    <Grid container justify="flex-start" style={{ height: 100, width: "100%" }}>
                                      <div
                                        style={{
                                          width: "100%",
                                          maxWidth: "100%",
                                          padding: 0,
                                          backgroundImage: "url(" + this.getAssetImageUrl(asset.id, sitecoreAssets) + ")",
                                          backgroundSize: "contain",
                                          backgroundRepeat: "no-repeat",
                                          backgroundPosition: "center,center"
                                        }}
                                        title={"loading image"}
                                      />
                                    </Grid>
                                    <div className="padding-bottom-24" />
                                  </Grid>
                                  <Grid item>
                                    <Typography variant="title" style={{ textAlign: 'center' }} gutterBottom>
                                      {asset.name}
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Grid container>
                                      {asset.environments.map((env: any) => {
                                        if (env.name === "Live") {
                                          return (
                                            <Grid key={env.name + env.id} item xs={6} style={{ borderRight: '1px solid lightgrey' }}>
                                              <Typography color="textSecondary" style={{ textAlign: 'center' }}>
                                                {env.name}
                                              </Typography>
                                              <Typography style={{ textAlign: 'center' }}>
                                                Active
                                                  </Typography>
                                              <Typography style={{ textAlign: 'center' }}>
                                                {env.states.find((s: any) => s.name === "Active") ? env.states.find((s: any) => s.name === "Active").subscriptions : 0} Subscriptions
                                                  </Typography>
                                              <Button  component={(componentProps: any) => <NavLink {...componentProps} to={"/asset-subscriptions/Live/" + asset.id} />} style={{ width: "100%", justifySelf: "center" }} color="secondary">
                                                MANAGE
                                                  </Button>
                                            </Grid>
                                          )
                                        }
                                        else { return null }
                                      })}
                                      {asset.environments.map((env: any) => {
                                        if (env.name === "Sandbox") {
                                          return (
                                            <Grid key={env.name + env.id} item xs={6} >
                                              <Typography color="textSecondary" style={{ textAlign: 'center' }}>
                                                {env.name}
                                              </Typography>
                                              <Typography style={{ textAlign: 'center' }}>
                                                Active
                                                  </Typography>
                                              <Typography style={{ textAlign: 'center' }}>
                                                {env.states.find((s: any) => s.name === "Active") ? env.states.find((s: any) => s.name === "Active").subscriptions : 0} Subscriptions
                                                  </Typography>
                                              <Button component={(componentProps: any) => <NavLink {...componentProps} to={"/asset-subscriptions/Sandbox/"+ asset.id} />} style={{ width: "100%", justifySelf: "center" }} color="secondary">
                                                MANAGE
                                                  </Button>
                                            </Grid>
                                          )
                                        }
                                        else { return null }
                                      })}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        )
                      })}
                    </Grid>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    )
  }

  private getAssetImageUrl(assetId: string, sitecoreAssets: ISitecoreAsset[]) {
    const asset = sitecoreAssets.find(sitecoreAsset => sitecoreAsset.id === assetId);
    if (asset && asset.imageUrl) {
      return asset.imageUrl;
    } else {
      return process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/-/media/logos/nxtport-logo.png";
    }
  }
}

export default Verifications;


// WEBPACK FOOTER //
// ./src/modules/subscription/pages/Verifications.tsx